import script from "./FormO2MFieldCombination.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormO2MFieldCombination.vue?vue&type=script&lang=ts&setup=true"

import "./FormO2MFieldCombination.vue?vue&type=style&index=0&id=c46c8958&scoped=true&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c46c8958"]])

export default __exports__